export default "__VITE_ASSET__BvQd1UKj__"